import React, { Component } from 'react';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import routers from './Configs/routes';
import createStore from './Redux';
import { Provider } from 'react-redux';
import './scss/app.scss';
const storeInstance = createStore();
class App extends Component {
  showRouter = () => {
    var result = null;
    if (routers.length > 0) {
      result = routers?.map((route, index) => {
        return (
          <Route
            key={index}
            path={route.path}
            exact={route.exact}
            component={route.main}
          ></Route>
        );
      });
    }
    return result;
  };

  render() {
    return (
      <Provider store={storeInstance}>
        <Router>
          <div className='app'>
            <Switch>{this.showRouter(routers)}</Switch>
          </div>
        </Router>
      </Provider>
    );
  }
}

export default App;
